import { fetchInsurancePolicy } from '@http/endpoints'

import payment from './payment'

export default {
  namespaced: true,

  modules: {
    payment,
  },

  state: () => ({
    billingAddress: {},
    coverage: {},
    insurance: {},
    isLoaded: false,
    userInformation: {},
  }),

  mutations: {
    setIsLoaded(state, isLoaded) {
      state.isLoaded = isLoaded
    },
    setBillingAddress(state, address) {
      state.billingAddress = address
    },
    setCoverage(state, coverage) {
      state.coverage = coverage
    },
    setInsurance(state, insurance) {
      state.insurance = insurance
    },
    setUserInformation(state, userInformation) {
      state.userInformation = userInformation
    },
  },

  getters: {
    billingAddress: (state) => state.billingAddress,
    coverage: (state) => state.coverage,
    insurance: (state) => state.insurance,
    isLoaded: (state) => state.isLoaded,
    userInformation: (state) => state.userInformation,
  },

  actions: {
    async fetch({ commit, dispatch }, { sessionId } = {}) {
      const { payload } = await dispatch(
        'http/request',
        {
          request: fetchInsurancePolicy,
          pathParams: { sessionId },
        },
        { root: true },
      )

      commit('setCoverage', payload.coverage)
      commit('setInsurance', payload.insurance)
      commit('setUserInformation', payload.userInformation)
      commit('setBillingAddress', payload.billingAddress)

      await dispatch('payment/fetchMethods')

      commit('setIsLoaded', true)
    },

    disableLoader({ commit }) {
      commit('setIsLoaded', true)
    },
  },
}
